module.exports = __webpack_public_path__ + "img/order-filter-active.acfff3ed.svg";